export default "__VITE_ASSET__D_T6Uu3u__"